import type { Nullable } from '@iheartjane/types';

export const useEnsureProductId = (
  possibleProductId?: Nullable<number | string>
) => {
  const numericId = Number(possibleProductId);

  if (!numericId || Number.isNaN(numericId)) {
    throw new Error(
      `[useEnsureProductId] Invalid product id: ${possibleProductId}`
    );
  }

  return numericId;
};
